
export class BlockInListDto {

    blockInListId;
    blockId;
    code;
    name;
    active;
    creationPerson;
    creationDate;
    modificationPerson;
    modificationDate;
    questionList;
    questionsInBlock = [];

    }